import {
    SliceFactory,
    FetchCollectionData,
    ApiCollectionResponse,
    FetchItemDataType,
} from '@europrocurement/l2d-redux-utils';
import {
    ConfigurationParameters as FactureOpenSearchApiConfigurationParameters,
    Configuration,
    FactureOpenSearchJsonldOpensearchFactureRead,
    FactureOpenSearchApi,
    FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest,
    FactureOpenSearchApiApiOpensearchFactureIdGetRequest,
    FactureOpenSearchOpensearchFactureReadDossiersInner,
} from '../../../openApi/ApiFacturation';
import { FACTURATION_REDUCER_NAME } from '../constants';

export const FACTURES_OPEN_SEARCH_PRESCRIBER_SLICE_NAME = 'factureOpenSearchPrescriber';

export type FactureOpenSearchPrescriberApiObject = FactureOpenSearchJsonldOpensearchFactureRead;

export type FactureOpenSearchPrescriber = {
    dossiers: Array<FactureOpenSearchOpensearchFactureReadDossiersInner>;
} & Record<string, unknown> &
    Omit<FactureOpenSearchPrescriberApiObject, 'dossiers'>;

export const mapperOpenSearchFacturePrescriber = function (
    factureMutliple: FactureOpenSearchPrescriber,
) {
    return {
        ...factureMutliple,
    } as FactureOpenSearchPrescriber;
};

type dateFilters = {
    startDate?: string;
    endDate?: string;
};

export function createFactureOpenSearchPrescriberSlice(
    configuration: FactureOpenSearchApiConfigurationParameters,
) {
    const conf = new Configuration(configuration);
    const api = new FactureOpenSearchApi(conf);

    const fetchFactureOpenSearchPrescriberCollection: FetchCollectionData<
        FactureOpenSearchPrescriber
    > = ({ search, pagination, filters, orders, preFilters, xIdSociete }) => {
        const options = undefined;
        let factureNumero: Array<string> = [];
        let dossierNumero: Array<string> = [];
        let reference: Array<string> = [];
        let status: Array<string> = [];
        let type: Array<string> = [];
        let clientId: Array<number> = [];
        let clientIdOperes: Array<number> = [];
        let prescripteurId: number | undefined;
        let ddmId: Array<number> = [];
        let dossierCollectionId: Array<number> = [];
        let dateDecheanceFactureDebut: string | undefined;
        let dateDecheanceFactureFin: string | undefined;
        let dateFactureDebut: string | undefined;
        let dateFactureFin: string | undefined;
        let totalTTC: number | undefined;
        let enPreparation: boolean | undefined;
        let orderFactureNumero: 'asc' | 'desc' | undefined;
        let orderReference: 'asc' | 'desc' | undefined;
        let orderdateDateEcheanceFacture: 'asc' | 'desc' | undefined;
        let orderSocieteFacturee: 'asc' | 'desc' | undefined;
        let orderTypeFormalite: 'asc' | 'desc' | undefined;
        let fGroupee: boolean | undefined;
        let fPayee: boolean | undefined;
        let q: string | undefined;

        if (filters.factureNumero) {
            factureNumero = [...factureNumero, filters.factureNumero as string];
        }
        if (filters.prescriberId) {
            prescripteurId = filters.prescriberId as number;
        }
        if (filters.ddmId) {
            ddmId = [...ddmId, filters.ddmId as number];
        }

        if (filters.dossierNumero) {
            dossierNumero = [...dossierNumero, filters.dossierNumero as string];
        }

        if (filters.referenceClient) {
            reference = [...reference, filters.referenceClient as string];
        }

        if (preFilters.status) {
            status = [...status, preFilters.status as string];
        }

        if (preFilters.fGroupee !== undefined) {
            fGroupee = preFilters.fGroupee as boolean;
        }

        if (preFilters.fPayee !== undefined) {
            fPayee = preFilters.fPayee as boolean;
        }

        if (filters.status) {
            status = [...status, filters.status as string];
        }

        if (filters.type) {
            type = [...type, filters.type as string];
        }
        if (filters.clientId) {
            clientId = [...clientId, filters.clientId as number];
        }
        if (filters.clientIdOperes) {
            clientIdOperes = [...clientIdOperes, filters.clientIdOperes as number];
        }

        if (filters.totalTTC) {
            totalTTC = filters.totalTTC as number;
        }
        if (filters.proforma !== undefined) {
            enPreparation = filters.proforma as boolean;
        }

        if (filters.collectionId) {
            dossierCollectionId = [...dossierCollectionId, filters.collectionId as number];
        }

        if (filters.dateEcheanceFacture) {
            const filtersDate = filters.dateEcheanceFacture as dateFilters;
            dateDecheanceFactureDebut =
                filtersDate?.startDate &&
                new Date(filtersDate.startDate).toLocaleDateString('fr-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });

            dateDecheanceFactureFin =
                filtersDate?.endDate &&
                new Date(filtersDate.endDate).toLocaleDateString('fr-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
        }

        if (filters.dateFacture) {
            const filtersDate = filters.dateFacture as dateFilters;
            dateFactureDebut =
                filtersDate?.startDate &&
                new Date(filtersDate.startDate).toLocaleDateString('fr-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
            dateFactureFin =
                filtersDate?.endDate &&
                new Date(filtersDate.endDate).toLocaleDateString('fr-CA', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                });
        }

        if (search && search !== '') {
            q = search;
        }

        if (orders.length > 0) {
            orders.forEach((order) => {
                if (order.field === 'factureNumero') {
                    orderFactureNumero = order.value;
                }
                if (order.field === 'reference') {
                    orderReference = order.value;
                }
                if (order.field === 'dateEcheanceFacture') {
                    orderdateDateEcheanceFacture = order.value;
                }
                if (order.field === 'societeFacturee') {
                    orderSocieteFacturee = order.value;
                }
                if (order.field === 'typeFormalite') {
                    orderTypeFormalite = order.value;
                }
            });
        }

        const requestParameters: FactureOpenSearchApiApiOpensearchFacturesGetCollectionRequest = {
            xIdSociete,
            page: pagination.page + 1,
            itemsPerPage: pagination.itemsPerPage,
            factureNumero,
            dossierNumero,
            reference,
            dateDecheanceFactureDebut,
            dateDecheanceFactureFin,
            orderFactureNumero,
            orderReference,
            orderdateDateEcheanceFacture,
            orderSocieteFacturee,
            orderTypeFormalite,
            dateFactureDebut,
            dateFactureFin,
            status,
            totalTTC,
            type,
            clientId,
            clientIdOperes,
            prescripteurId,
            ddmId,
            enPreparation,
            fGroupee,
            fPayee,
            dossierCollectionId,
            q,
        };

        return api
            .apiOpensearchFacturesGetCollection(requestParameters, options)
            .then((res) => res.data) as Promise<ApiCollectionResponse<FactureOpenSearchPrescriber>>;
    };

    const fetchFactureOpenSearchPrescriberItem: FetchItemDataType<FactureOpenSearchPrescriber> = ({
        idItem,
        xIdSociete,
    }) => {
        const requestParameters: FactureOpenSearchApiApiOpensearchFactureIdGetRequest = {
            id: String(idItem),
            xIdSociete,
        };

        return api
            .apiOpensearchFactureIdGet(requestParameters)
            .then((res) => res.data) as Promise<FactureOpenSearchPrescriber>;
    };

    const {
        slice: factureOpenSearchPrescriberSlice,
        dataSourcesThunks: factureOpenSearchPrescriberDataSourcesThunks,
    } = SliceFactory.createSlice<FactureOpenSearchPrescriber, FactureOpenSearchPrescriber>(
        FACTURES_OPEN_SEARCH_PRESCRIBER_SLICE_NAME,
        FACTURATION_REDUCER_NAME,
        [],
        fetchFactureOpenSearchPrescriberCollection,
        fetchFactureOpenSearchPrescriberItem,
        mapperOpenSearchFacturePrescriber,
        {},
        undefined,
    );

    return { factureOpenSearchPrescriberSlice, factureOpenSearchPrescriberDataSourcesThunks };
}
